import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Field, reduxForm } from "redux-form"
import Typography from "@material-ui/core/Typography/Typography"
import Fade from "@material-ui/core/Fade"
import withStyles from "@material-ui/core/styles/withStyles"
import withTheme from "@material-ui/core/styles/withTheme"
import { translate } from "react-i18next"
import flow from "lodash/flow"

import { validatePresence as validate } from "./validate"
import styles from "./styles"
import AppicalTextField from "../../lib/views/AppicalTextField/AppicalTextField"
import AppicalPasswordField from "../../lib/views/AppicalPasswordField/AppicalPasswordField"
import Logo from "../../lib/views/Icons/Logo"
import Button from "../../lib/views/Button/Button"
import { isCurrentCompanyAppical } from "../../constants"

export class LoginForm extends React.Component {
    constructor(props) {
        super(props)

        this.passwordRef = null
    }

    focusPasswordField() {
        if (this.passwordRef) {
            this.passwordRef.focus()
        }
    }

    render() {
        const {
            t, classes, theme, handleSubmit, submitting, isEmailChecked, onEmailChanged,
            invalid,
        } = this.props

        if (isEmailChecked) {
            this.focusPasswordField()
        }

        let color = theme.palette.primary.contrastText
        let height = 142
        let width = 142
        const companyName = process.env.REACT_APP_COMPANY_NAME
        let welcomeTitle = `${t("main:welcome")} ${process.env.REACT_APP_DISPLAY_NAME}`
        if (isCurrentCompanyAppical) {
            color = theme.palette.primary.main
            height = 120
            width = 120
            welcomeTitle = t("main:log_in")
        }
        if (companyName === "allianzgi"){
            welcomeTitle= "Start your onboarding journey with AllianzGI here"
        }
        if (companyName === "capgemini") {
            height = "unset"
            width = "unset"
        }
        if (companyName === "worldline") {
            welcomeTitle = t("main:welcome_wordline")
        }
        if (companyName === "kpmg") {
            welcomeTitle = process.env.REACT_APP_DISPLAY_NAME
        }
        return (
            <form className={classes.form} onSubmit={handleSubmit}>
                <div className={classes.appicalLogo}>
                    <Logo
                        color={color}
                        height={height}
                        width={width}
                    />
                </div>
                <Typography
                    variant="subtitle1"
                    align="center"
                    className={classes.welcomeTitle}
                >
                    {welcomeTitle}
                </Typography>
                {companyName === "kpmg" && (
                    <Typography
                        variant="subtitle1"
                        align="center"
                        className={classes.welcomeTitle2}

                    >
                        {t("main:welcome_kpmg")}
                    </Typography>
                )}
                {companyName === "kpmg" && (
                    <div className={classes.createAccountButtonWrapper}>
                        <Typography
                            variant="caption"
                            className={classes.dontHaveAccountKmpg}
                        >
                            {t("main:don_t_have_an_account")}
                        </Typography>
                        <Typography
                            to="/invite"
                            className={classes.createAccountKmpg}
                            component={Link}
                            variant="caption"
                        >
                            {t("main:sign_up_here")}
                        </Typography>
                    </div>
                )}
                {(isCurrentCompanyAppical) && (
                    <div className={classes.createAccountButtonWrapper}>
                        <Typography
                            variant="caption"
                            className={classes.createAccountText}
                        >
                            {t("main:don_t_have_an_account")}
                        </Typography>
                        <Typography
                            to="/invite"
                            className={classes.createAccountLink}
                            component={Link}
                            variant="caption"
                        >
                            {t("main:sign_up_here")}
                        </Typography>
                    </div>
                )}

                <Field
                    name="username"
                    autofocus
                    component={AppicalTextField}
                    type="email"
                    autocorrect="off"
                    autocapitalize="none"
                    label={t("main:email")}
                    onChange={onEmailChanged}
                    className={isCurrentCompanyAppical ? classes.input : ""}
                    hasLabel={isCurrentCompanyAppical}
                />

                <div className={classes.flex}>
                    <Fade
                        id="password-field"
                        className={isEmailChecked
                            ? classes.showPasswordField
                            : classes.hidePasswordField}
                        in={isEmailChecked}
                    >
                        <div>
                            <Field
                                name="password"
                                inputRef={(input) => { this.passwordRef = input }}
                                component={AppicalPasswordField}
                                type="password"
                                label={t("main:password")}
                                className={isCurrentCompanyAppical ? classes.input : ""}
                                hasLabel={isCurrentCompanyAppical}
                            />
                        </div>
                    </Fade>
                </div>
                <div className={classes.buttonContainer}>
                    <Button
                        type="login"
                        disabled={invalid || submitting}
                        loader={submitting}
                        className={classes.loginButton}
                    >
                        {t((isEmailChecked) ? "main:login" : "main:next")}
                    </Button>
                </div>
                    <div className={classes.textBelow}>
                        <Fade unmountOnExit in={true}>
                            <Typography
                                variant="caption"
                                align="center"
                                className={classes.simpleLink}
                                to="/reset-password"
                                component={Link}
                            >
                                {t("main:forgot_password")}
                            </Typography>
                        </Fade>
                    </div>
            </form>
        )
    }
}


LoginForm.propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    isEmailChecked: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    values: PropTypes.object,
    onEmailChanged: PropTypes.func,
}

LoginForm.defaultProps = {
    onEmailChanged: null,
    values: undefined,
}

export default flow([
    reduxForm({
        form: "login",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate,
    }),
    translate(),
    withStyles(styles),
    withTheme(),
])(LoginForm)
